import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent} from './home/home.component';
import { WebComponent } from './web/web.component';
import { PhotographyComponent } from './photography/photography.component';
import { ContactComponent } from './contact/contact.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { LoginComponent } from "./user/login/login.component";
import { RegisterComponent  } from "./user/register/register.component";
import { DashboardComponent  } from "./user/dashboard/dashboard.component";
import { WebDashboardComponent } from './user/dashboard/web-dashboard/web-dashboard.component';
import { PhotographyDashboardComponent } from './user/dashboard/photography-dashboard/photography-dashboard.component';
import { MessageDashboardComponent } from './user/dashboard/message-dashboard/message-dashboard.component';
import { UserDashboardComponent } from './user/dashboard/user-dashboard/user-dashboard.component';
import { ItemDetailsComponent } from './item-details/item-details.component';
import { ItemEditComponent } from './user/dashboard/item-edit/item-edit.component';
import { ItemAddComponent } from './user/dashboard/item-add/item-add.component';

const routes: Routes = [
  { path: 'home', redirectTo: '/', pathMatch: 'full' , data: { bc: 'Looking outside' }},
  { path: '', component: HomeComponent, data: { bc: 'Home' }},
  { path: 'web', component: WebComponent, data: { bc: 'Web' } },
  { path: 'web/:url', 
    component: ItemDetailsComponent, data: { bc: 'Web' }
  },
  { path: 'photography', component: PhotographyComponent, data: { bc: 'Photography' } },
  { path: 'photography/:url', 
    component: ItemDetailsComponent, data: { bc: 'Photography' }
  },
  { path: 'contact', component: ContactComponent, data: { bc: 'Contact' } },
  { path: 'user/login', component: LoginComponent, data: { bc: 'user/login' } },
  { path: 'user/registration', component: RegisterComponent, data: { bc: 'user/registration' } },
  { path: 'user/dashboard/main', component: DashboardComponent, data: { bc: 'user/dashboard/main' } },
  { path: 'user/dashboard/web', component: WebDashboardComponent, data: { bc: 'user/dashboard/web' } },
  { path: 'user/dashboard/web/add', component: ItemAddComponent, data: { bc: 'user/dashboard/web' } },
  { path: 'user/dashboard/web/edit/:id', component: ItemEditComponent, data: { bc: 'user/dashboard/web/edit' } },
  { path: 'user/dashboard/photography', component: PhotographyDashboardComponent, data: { bc: 'user/dashboard/photography' } },
  { path: 'user/dashboard/photography/add', component: ItemAddComponent, data: { bc: 'user/dashboard/photography/add' } },
  { path: 'user/dashboard/photography/edit/:id', component: ItemEditComponent, data: { bc: 'user/dashboard/photography/edit' } },
  { path: 'user/dashboard/message', component: MessageDashboardComponent, data: { bc: 'user/dashboard/message' } },
  { path: 'user/dashboard/user', component: UserDashboardComponent, data: { bc: 'user/dashboard/user' } },
  { path: "**", component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

export const routingComponents = [
  HomeComponent,
  WebComponent,
  ItemDetailsComponent,
  PhotographyComponent,
  ContactComponent,
  LoginComponent,
  RegisterComponent,
  DashboardComponent,
  PageNotFoundComponent
]